module.exports = __webpack_public_path__ + "img/A901.5b913f7f.jpg";